import React from 'react';
import ExperienceSection from '../components/ExperienceSection';

const ExperiencesPage = props => (
  <div className="experience page">
    <h1>Experiences</h1>
    <ExperienceSection
      roundImage={props.data.robExperienceImage.edges[0].node}
      fullImage={props.data.robExperienceImageFull.edges[0].node}
      title="The Robert Gesink Experience"
    >
      <p>If you want to ride with Robert, from now on that’s possible! We will host a ride with Robert a few times a year.</p>
      <p>Starting the day with a ride through the beautiful roads of Girona, coffee during the ride and a dinner in our private garden cooked by Daisy.</p>
      <p>Why are we doing it in our garden? Robert is a family man and being at home with the kids is the most important thing for him. That’s why we decided to open our garden a few times a year for a group of max 10 people. Daisy will be making a delicious dinner on your request and the kids will be walking around and have a chat with you as well if they wanted.</p>
      <p>We live in the heart of Girona’s Old Town, in one of the oldest streets of the city and we have a lovely little garden that is perfect to host these events.</p>
      <p>If you don’t want to ride but only want to have an evening or a ride with Robert that’s also possible. We can help you arrange your flights, hotel in the city center and everything you’ll need.</p>
      <p>A little extra we offer is a professional photographer.</p>
      <p>We are not doing it to often because Robert is an professional cyclist riding a full season, but if you are interested and want to know more about The Robert Gesink Experience send us an email and we will see how to make it happen.</p>
    </ExperienceSection>

    <ExperienceSection
      roundImage={props.data.tuiExperienceImage.edges[0].node}
      title="TUI"
    >
      <p>For the Dutch Cycling fans we offer a special trip, organized by Daisy and the Dutch travel company TUI. It’s a three days trip including: flight, hotel, welcome package, riding with Robert, dinner in the garden and a tour through Girona.</p>
    </ExperienceSection>

  </div>
);

export default ExperiencesPage;

export const experienceQuery = graphql`
  query experienceQuery {
    robExperienceImage: allFile(filter:{name:{eq:"experience"}}){
      edges {
        node {
          name
          childImageSharp {
            resolutions(width: 180, height: 180, quality: 75) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
    tuiExperienceImage: allFile(filter:{name:{eq:"robExperience"}}){
      edges {
        node {
          name
          childImageSharp {
            resolutions(width: 180, height: 180, quality: 75) {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
    robExperienceImageFull: allFile(filter:{name:{eq:"robExperienceBig"}}){
      edges {
        node {
          name
          childImageSharp {
            sizes(maxWidth: 775, quality: 75) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/experiences.js